import { LEVELS, GRADIENT_CSS } from "@/lib/heat";

export const HeatLegend = () => (
  <div data-testid="heat-legend" className="avoid-break">
    <div className="h-2.5 w-full rounded-full" style={{ background: GRADIENT_CSS }} />
    <div className="mt-2 grid grid-cols-4 text-[10px] sm:text-xs text-slate-500">
      {LEVELS.map((s, i) => (
        <div key={s.label} className={i === 3 ? "text-right" : i === 0 ? "text-left" : "text-center"}>
          <div className="font-semibold" style={{ color: s.hex }}>{s.label}</div>
          <div className="font-mono">{s.min}–{s.max} pts</div>
        </div>
      ))}
    </div>
    <p className="mt-2 text-xs text-slate-500">Centre of the flower = 0 · Petal tips = 36 (highest possible per area)</p>
  </div>
);
